interface IconProps {
    width?: string;
    height?: string;
    className?: string;
}

const DashboardIcon = ({ width = '20', height = '20', className = '' }: IconProps) => {
    return (
        <span className={className}>
            <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.51602 2.36664L3.02435 5.86664C2.27435 6.44997 1.66602 7.69164 1.66602 8.63331V14.8083C1.66602 16.7416 3.24102 18.325 5.17435 18.325H14.8244C16.7577 18.325 18.3327 16.7416 18.3327 14.8166V8.74997C18.3327 7.74164 17.6577 6.44997 16.8327 5.87497L11.6827 2.26664C10.516 1.44997 8.64102 1.49164 7.51602 2.36664Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.75 9.58337L10.25 13.0834L8.91667 11.0834L6.25 13.75"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.084 9.58337H13.7507V11.25"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    );
};

export default DashboardIcon;
